import { FilesApi } from "api/FilesApi";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { easasAlert } from "../../fragments/easas-global-fragment/EasasGlobalAlerts";

export type FileUploaderRef = {
    upload: () => void;
}

interface FileUploadParams {
    desc?: string;
    fileTags?: string[];
    isPublic?: boolean;
    onUploaded?: () => void;
    onErrored?: () => void;
}


export const FileUploader = forwardRef<FileUploaderRef, FileUploadParams>(
  function FileUploader(props, ref) {
    const fileUpRef = useRef<FileUpload>(null);

    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    useImperativeHandle(ref, () => ({
      upload() {
        upload();
      },
    }));

    const upload = () => {
      fileUpRef.current!!.upload();
    };

    const onUploaded = () => {
      if (props.onUploaded) {
        props.onUploaded();
      }
    };

    const onErrored = () => {
      if (props.onErrored) {
        props.onErrored();
      }
    };

    const uploadHandler = (event: FileUploadHandlerParam) => {
      console.log("uploadHandler", event);
      if (event.files.length === 0) {
        easasAlert({ summary: "No files selected", severity: "warn" });
        return;
      }

      setIsUploading(true);

      const apiCall = props.isPublic
        ? () => FilesApi.uploadPublicFile(event.files[0], props.desc, props.fileTags, onProgress)
        : () => FilesApi.uploadFile(event.files[0], props.desc, props.fileTags, onProgress);

      apiCall().then(r => {
        setIsUploading(false);

        if (!r.error) {
          easasAlert("File uploaded");
          onUploaded();
          fileUpRef.current!!.clear();
        } else {
          easasAlert({ summary: "Error uploading file", severity: "error" });
          onErrored();
        }
      });
    };

    const onProgress = useCallback((event: number) => {
      setUploadProgress(event);
      console.log("onProgress", uploadProgress);
    }, []);

    return (
      <>
        <FileUpload
          ref={fileUpRef}
          mode="basic"
          customUpload
          uploadHandler={uploadHandler}
          disabled={isUploading}
        />

        {isUploading && (
          <div>
            Uploading...
            <ProgressBar value={uploadProgress} />
          </div>
        )}
      </>
    );
  }
);